import { createSlice } from '@reduxjs/toolkit';
import { useHistory } from 'react-router-dom';

// Slice
const initialEmployeeProfile = localStorage.getItem('credentials')
    ? JSON.parse(localStorage.getItem('credentials'))
    : null

const slice = createSlice({
    name: 'credentials',
    initialState: {
        employeeProfile: initialEmployeeProfile,
    },
    reducers: {
        saveEmployeeProfileInfo: (state, action) => {
            state.employeeProfile = action.payload;
            if (action.payload) localStorage.setItem('credentials', JSON.stringify(action.payload));
        }
    },
});

export default slice.reducer;

// Actions
const { saveEmployeeProfileInfo } = slice.actions;

export const saveEmployeeProfile = (data) => async dispatch => {
    try {
        dispatch(saveEmployeeProfileInfo(data));
    } catch (e) {
        return console.error(e.message);
    }
}
